import { useTranslation } from "react-i18next";
import { IChatMessageItem } from "../../chats-panel/MessageItem/~types/MessageItemProps";
import './ReplyMessagePanel.css';
import { MessageType } from "../../chats-panel/~store/models/MessageItem";

interface IReplyMessagePanelProps {
    message: IChatMessageItem;
    onClose: () => void;
    clientName?: string;
}

export const ReplyMessagePanel = (props: IReplyMessagePanelProps) => {
    const { t } = useTranslation();

    const getPreviewText = () => {
        if (props.message.text && props.message.text.trim().length > 0) {
            return props.message.text;
        }

        if (props.message.imageId || props.message.fileId) {
            return t("common.attachment");
        }

        if (props.message.location) {
            return t("common.location");
        }

        return "";
    };

    const getReplyAuthor = () => {
        if (props.message.messageType === MessageType.clientMessage) {
            return props.clientName?.trim() || t("chats.messageFromClient");
        }
        return props.message.operatorName?.trim() || props.message.senderName;
    };

    return (
        <div className="reply-message-panel">
            <div className="reply-message-panel__left-border"></div>

            <div className="reply-message-panel__body">
                <div className="reply-message-panel__header">
                    <span className="reply-message-panel__title">
                        {t("chat.reply")}
                    </span>

                    <div
                        className="reply-message-panel__close"
                        onClick={props.onClose}
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                props.onClose();
                            }
                        }}
                    >
                        <i className="material-icons">close</i>
                    </div>
                </div>

                <div className="reply-message-panel__text">
                     <strong>{getReplyAuthor()}: </strong>
                    {getPreviewText()}
                </div>
            </div>
        </div>
    );
};